import axios from "axios";

// Axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // base URL
});

// Request Interceptor
service.interceptors.request.use(
  (config) => {
    config.headers = {
      // "content-type": "application/json",
      Accept: "application/json",
      // 'Access-Control-Allow-Origin': "*",
      Authorization: "Bearer " + localStorage.getItem("token") || null,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 404) {
      // Handle 404 error
      return error?.response;
    }
    if (error?.response?.status === 401) {
      window.location.href = "/";
    }
    // Default error handling
    return Promise.reject(error);
  }
);

export default service;
